export default __webpack_public_path__ + "static/media/mute.fa7ec39c.png";